export enum UrgencyMessageType {
    FewTickets = 'fewTickets',
    GoingFast = 'goingFast',
    SalesEndSoon = 'salesEndSoon',
}

export enum UrgencyCategoryType {
    EarlyBird = 'earlyBird',
    Popular = 'popular',
    New = 'new',
}

export type UrgencyMessages = Record<string, boolean>;

export type UrgencyCategories = Record<string, boolean>;

export type UrgencySignalsProps =
    | {
          messages: UrgencyMessages;
          categories: UrgencyCategories;
      }
    | undefined;

export type EnabledUrgencySignals = {
    messages: Record<string, boolean | undefined>;
    categories: Record<string, boolean | undefined>;
};
